import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'react-i18next';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import styles from './styles';
import FindingsService from '@Services/Findings';
import { moveFindingsToLegal }  from "@Actions/findingsActions";
import { updateDomainFindingCount, updateDomain }  from "@Actions/domainsActions";
import DomainsService from '@Services/Domains';

class MoveToLegalButton extends Component {
  constructor(props) {
    super();
  }

  state = {
    btnDisabled: false,
  };


  btnClicked() {
    this.setState({btnDisabled:true});
    FindingsService.moveFindingsToLegal(this.props.data).then(
      (response) => {
        this.setState({btnDisabled:false});
        this.props.actionMoveFindingsToLegal(this.props.data);
        // this.props.actionUpdateDomainFindingCount(this.props.data, -1);
        DomainsService.getDomain({domainId:this.props.data.domainId}).then((response) => {
          this.props.actionuUpdateDomain({domainId: this.props.data.domainId, results: response});
        }).catch((error) => {
          // this.props.actionShowSnackbar({ message: this.props.t("_something_went_wrong_please_try_again_later"), variant: "error" });
          console.log(error);
        });
      }).catch((error) => {
        this.setState({btnDisabled:false});
        // this.props.actionShowSnackbar({ message: this.props.t("_something_went_wrong_please_try_again_later"), variant: "error" });
        console.log(error);
      });
  }  

  render() {
    const { classes, t } = this.props;

    return (
      <div className={classes.root}>
          <Button variant="contained"  disabled={this.state.btnDisabled} color="default" className={classes.button}  onClick={() => this.btnClicked()}>
            {t("_mark_as_legal")}      
          </Button>
      </div>
    );
  }

}

MoveToLegalButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state){
  return {
    
  };
}

function matchDispatchToProps(dispatch){
  return bindActionCreators(
    {
      actionMoveFindingsToLegal: moveFindingsToLegal,
      actionUpdateDomainFindingCount : updateDomainFindingCount,
      actionuUpdateDomain:updateDomain
    }, dispatch);
}

export default withStyles(styles)(translate("translations")(connect(mapStateToProps,matchDispatchToProps)(MoveToLegalButton)));